import "./Hero.css";

const Hero = () => {
  return (
    <div className="pricing-hero-container">
      <div className="pricing-hero-left">
        <div className="pricing-hero-mainText">
          <h1>Don’t break a sweat. Don’t break the bank</h1>
        </div>
        <div className="pricing-hero-subText">
          <p>
            To make things better, we have pricing that’d leave a smile on your
            face. 
          </p>
          <div className="pricing-sub-container non-pricing-mobile">
            <div className="pricing-sub-flex top-sub">
                        
                      <p className="sub-sub-pricing">
                        <img  className = "pricing-checkmark" src="./assets/checkmark.svg" alt="" />
                        Transaction fees capped at
                        <span className="twofive"> ₦500</span>
                      </p>
                      </div>

                      <div className="pricing-sub-flex">
                        
                        <p className="sub-sub-pricing">
                        <img className = "pricing-checkmark" src="./assets/checkmark.svg" alt="" />
                        <span className="twofive">₦50 </span>
                        Stamp duty charge on transactions
                        <span className="twofive"> ₦10,000 </span>
                        and above
                      </p>
                      </div>
          </div>
          
          
          
        </div>
      </div>
      <div className="pricing-hero-right ">
        <img src="/assets/pricing.svg" alt="" />
      </div>

      <div className="pricing-sub-container only-pricing-mobile">
            <div className="pricing-sub-flex top-sub">
                        
                      <p className="sub-sub-pricing">
                        <img  className = "pricing-checkmark" src="./assets/checkmark.svg" alt="" />
                        Transaction fees capped at
                        <span className="twofive"> ₦500</span>
                      </p>
                      </div>

                      <div className="pricing-sub-flex">
                        
                        <p className="sub-sub-pricing">
                        <img className = "pricing-checkmark" src="./assets/checkmark.svg" alt="" />
                        <span className="twofive">₦50 </span>
                        Stamp Duty Charge on transactions
                        <span className="twofive"> ₦10,000 </span>
                        and above
                      </p>
                      </div>
          </div>
    </div>
  );
};

export default Hero;
